<section class="cg-resizeable-height-container" [style.height.px]="height">
  <div class="cg-resizeable-height-container__content">
    <ng-content></ng-content>
  </div>
  <div
    class="cg-resizeable-height-container__handle"
    (drag)="drag($event)"
    (dragstart)="dragStart($event)"
    (dragend)="dragEnd($event)"
    draggable="true"
  >
    <div class="cg-resizeable-height-container__handle--icon">
      <cigna-icon-triangle
        size="medium"
        color="grey"
        direction="north"
        style="display: block;"
      ></cigna-icon-triangle>
      <cigna-icon-triangle
        size="medium"
        color="grey"
        direction="south"
        class="cg-margin-top-xs"
        style="display: block;"
      ></cigna-icon-triangle>
    </div>
  </div>
</section>
